/** Same base resolution as Checkout.jsx for order + funnel API calls. */
export function pickLbApiBase() {
  const dev = import.meta.env.VITE_DEV_LB_API_URL;
  const staging = import.meta.env.VITE_STAGING_LB_API_URL;
  const stable = import.meta.env.VITE_STABLE_LB_API_URL;
  const forceStaging =
    import.meta.env.VITE_USE_STAGING_API === "true" ||
    import.meta.env.VITE_USE_STAGING_API === true;

  if (import.meta.env.DEV && dev) {
    return dev;
  }
  if (!import.meta.env.DEV && forceStaging) {
    return staging || dev || stable;
  }
  return stable || dev;
}
